import { createModel } from "hox";
import { useMemo, useRef, useState } from "react";
import { OptionDsType, ReceiverType } from "@src/types/FmsTypes";
import { noticeService } from "../NoticeService";
import { IMdNoticeDetail, IMdNoticeFields } from "../NoticeTypes";
import { IYhFormRef } from "@src/components/YhFormBox/Types";
import { globalPrompt } from "@src/components/YhMessage";
import moment from "moment";
import { UploadFile } from "antd/lib/upload/interface";
import { convertRes2Blob } from "@src/utils/exportFile";
import { useNoticeModel } from "../summary/summaryModel";
import useNavModel from "@src/model/navModel";
import debounce from 'lodash/debounce';
import { useLockFn } from "ahooks";


function useModel() {
  const { addNav } = useNavModel()
  const { selectedRowData, setDrawerVisible, setPreviewData, setPreviewDisabled, setSelectedRowData, loadData, editModel, setEditModel } = useNoticeModel()

  //列表数据源分页参数
  const formRef = useRef<IYhFormRef>();
  const fetchRef = useRef(0);
  const [loading, setLoading] = useState(false);

  const [formCache, setformCache] = useState<any>()

  const [receiverTypeCode, setReceiverTypeCode] = useState<ReceiverType>()
  const [receiverCode, setReceiverCode] = useState<string>()
  const [userList, setUserList] = useState<OptionDsType[]>([])

  /**
   * 提交
   */
  const onSubmit = useLockFn(async (type: 'publish' | 'save') => {
    if (editModel === 'look') return onCancel()
    try {
      const formData = await formRef.current?.validateFields();
      if (formData) {
        console.log('formData: ', formData)
        if (formData.receiverTypeCode === 'ORG' && formData?.receiverValue?.length === 0) return globalPrompt('message', { type: 'warning', text: "请选择机构" })
        if (formData.receiverTypeCode === 'USER' && formData?.receiverUserCode?.length === 0) return globalPrompt('message', { type: 'warning', text: "请选择用户" })
        if (!formData.allTime && !formData.limitTime) return globalPrompt('message', { type: 'warning', text: "请选择时效日期" })
        const params = {
          ...formData,
          code: formData.code ?? '',
          pubTime: formData.pubTime ? moment(formData.pubTime).format("YYYY-MM-DD HH:mm:ss") : undefined,
          limitTime: formData.allTime ? "2099-10-30 00:00:00" : formData.limitTime ? moment(formData.limitTime).format("YYYY-MM-DD HH:mm:ss") : "", 
          content: formData.content.toText(),
          contentHtml: formData.content.toHTML(),
          receiverUserCode: undefined,
          receiverValue: formData.receiverTypeCode === 'USER' ? formData.receiverUserCode
            : formData.receiverTypeCode === 'ORG' ? formData.receiverValue : [],
          attachCode: formData.attachCode?.map((item: any) => item.uid)
        }
        // console.log(type)
        // console.log(params,formData)
        setLoading(true)
        if (type === 'save') return onSave(params)
        if (type === 'publish') return onPublish(params)
      }
    } catch (e) {
      console.log("失败!");
    }
  })

  /**
   * 取消
   */
  const onCancel = () => {
  }
  /**
   * 预览
   */
  const onPreview = async () => {
    try {
      // const formData = await formRef.current?.validateFields();
      // if (formData) {
      //   const params = {
      //     ...formData,
      //     pubTime: formData.pubTime ? moment(formData.pubTime).format("YYYY-MM-DD HH:mm:ss") : undefined,
      //     limitTime: formData.limitTime ? moment(formData.limitTime).format("YYYY-MM-DD HH:mm:ss") : undefined,
      //     contentHtml: formData.content.toHTML(),
      //     attachInfo: formData.attachCode.map((item: any) => {
      //       return {
      //         fileCode: item.uid,
      //         fileType: item.type,
      //         fileSize: item.size,
      //         attachName: item.name
      //       }
      //     })
      //   }
      cacheData()
      let formData = formCache ?? await formRef.current?.validateFields();
      const params = {
        ...formData,
        id: editModel === 'add' ? '' : selectedRowData?.id,
        pubTime: formData.pubTime ? moment(formData.pubTime).format("YYYY-MM-DD HH:mm:ss") : undefined,
        limitTime: formData.limitTime ? moment(formData.limitTime).format("YYYY-MM-DD HH:mm:ss") : undefined,
        contentHtml: formData?.content?.toHTML?.(),
        attachInfo: formData?.attachCode?.map((item: any) => {
          return {
            fileCode: item.uid,
            fileType: item.type,
            fileSize: item.size,
            attachName: item.name,
            id: item.uid
          }
        })
      }
      setPreviewDisabled(true)
      setPreviewData(params)
      setDrawerVisible(true)
    } catch (e) {
      console.log("失败!", e);
    }
  }

  const onPublish = async (params: IMdNoticeFields) => {
    if (editModel === 'look') return onCancel()
    try {
      const insertRet = await noticeService.publish(params);
      if (insertRet.success) {
        await globalPrompt("message", { type: "success", text: '发布成功!' });
        setSelectedRowData({} as IMdNoticeDetail)
        addNav("portal-04")
        setEditModel("add")
        loadData().then()
      } else {
        await globalPrompt("message", { type: "error", text: "发布失败!" + insertRet.retMsg });
      }
    } catch (e) {
      console.log("失败!");
    } finally {
      setLoading(false)
    }
  }
  /**
   * 保存
   */
  const onSave = async (params: IMdNoticeFields) => {
    if (editModel === 'look') return onCancel()
    try {
      if (editModel !== "edit") {
        const insertRet = await noticeService.insert(params);
        if (insertRet.success) {
          await globalPrompt("message", { type: "success", text: '新增成功!' });
          setSelectedRowData({} as IMdNoticeDetail)
          addNav("portal-04")
          setEditModel("add")
          loadData().then()
        } else {
          await globalPrompt("message", { type: "error", text: "新增失败!" + insertRet.retMsg });
        }
      } else {
        const updateRet = await noticeService.update(params);
        if (updateRet.success) {
          await globalPrompt("message", { type: "success", text: '修改成功!' });
          setSelectedRowData({} as IMdNoticeDetail)
          addNav("portal-04")
          setEditModel("add")
          loadData().then()
        } else {
          await globalPrompt("message", { type: "error", text: "修改失败!" + updateRet.retMsg });
        }
      }
    } catch (e) {
      console.log("失败!");
    } finally {
      setLoading(false)
    }
  }

  const downloadFile = async (id: string) => {
    try {
      let result = await noticeService.downloadFile(id);
      convertRes2Blob(result);
    } catch (error) {
      console.error(error)
    }
  }

  const debounceFetcher = useMemo(() => {
    const loadOptions = async (key: string) => {
      try {
        fetchRef.current += 1;
        const fetchId = fetchRef.current;

        if (receiverCode === key) return

        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }
        setReceiverCode(key)
        cacheData({ receiverTypeCode: 'USER', receiverValue: undefined })
        // cacheData({ receiverTypeCode: 'USER', receiverValue: key })
        // const user = await noticeService.findUserByOrg(key) 
        const user = await noticeService.findUserAll()
        setUserList(user)
      } catch (error) {
        console.log("error: ", error)
      }
    };

    return debounce(loadOptions, 10);
  }, [receiverCode]);

  const cacheData = async (data?: any) => {
    const formData = await formRef.current?.getFieldsValue()
    const cache = {
      ...formData,
      ...data
    }
    console.log('formCache:', cache)
    setformCache(cache)
  }
  const onLoadUserByOrg = async (key: string) => {
    try {
      if (!key) return
      if (receiverCode === key) return
      setReceiverCode(key)
      const formData = await formRef.current?.getFieldsValue()
      console.log('formCache:', formData)
      setformCache({
        ...formData,
        receiverValue: key
      })
      // const user = await noticeService.findUserByOrg(key);
      const user = await noticeService.findUserAll()
      setUserList(user)
    } catch (error) {
      console.log("error: ", error)
    }

  }

  return {
    /***field***/
    formRef,
    receiverTypeCode,
    userList,
    formCache,
    loading,

    /***method***/
    loadData,
    onSubmit,
    onCancel,
    onPreview,
    setReceiverTypeCode,
    setUserList,
    downloadFile,
    onLoadUserByOrg,
    debounceFetcher,
    cacheData,
    setformCache
  }

}


export const useNoticeDetailModel = createModel(useModel);